import { Navigate } from 'react-router-dom';
import { useAppContext } from '../Context/AppContext';
import { getAuthenticatedHomePath } from '../Shared/homePath';

const ManagerRoute = ({ children }) => {
	const { state } = useAppContext();

	if (!state.user.id) {
		return null;
	}

	if (state.user.isSuperuser || state.user.role === 'Manager') {
		return children;
	}

	return <Navigate to={getAuthenticatedHomePath(state.user)} replace />;
};

export default ManagerRoute;
